import * as React from "react";
import { Container, Tab, Tabs, Spinner, Stack, Card } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Prompt from "../ui/prompts/Prompt";
import { Title, ContentHeader, ViewsContainer, SpinnerContainer, CenteredAlignedContainer } from "../ui/BaseComponents";

 export default function ViewAdmin({ data, isLoading}) {
  const settingsMessage = "This will contain various settings to update or delete admin account"
  const suspendedMessage = "This will contain all pending providers that have been previously rejected by an admin"

    return (
      <Container fluid>
            <Title>{"Admin Page"}</Title>
              {isLoading ? (
                <SpinnerContainer>
                  <Spinner animation="grow" variant="danger" />
                  <Spinner animation="grow" variant="danger" />
                  <Spinner animation="grow" variant="danger" />
                </SpinnerContainer>
              ) : (

              
        <Stack>
          <ContentHeader>{"Admin"}</ContentHeader>
          <Row className="justify-content-md-center">
            <Col xs lg="8">
              <ViewsContainer style={{ padding: '1em', margin: '0 1.10%'}}>
                <Tabs
                  defaultActiveKey="info"
                  id="fill-tab-example"
                  className="mb-3"
                  fill>
                  <Tab eventKey="info" title="Info">
                  <CenteredAlignedContainer>
                    <Card style={{ width: '33%' }}>
                      <Card.Header><b>Admin Profile</b></Card.Header>
                      <Card.Body>
                        <Card.Title>{data.first_name} {data.last_name}</Card.Title>
                        <Card.Text>
                          <p>{data.email}</p>
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </CenteredAlignedContainer>
                    
                  </Tab>
                  <Tab eventKey="suspended" title="Suspended">
                    <Prompt message={suspendedMessage} />
                  </Tab>
                  <Tab eventKey="settings" title="Settings">
                    <Prompt message={settingsMessage} />
                  </Tab>
                </Tabs>
              </ViewsContainer>
            </Col>
          </Row>
        </Stack>
        )}
      </Container>
     )
 }